import compact from 'lodash/compact';

export const arrayFromDelimitedString = (string, delimeter = ',') => compact((string || '').split(delimeter));
